if (!customElements.get('union-hoodie-gallery')) {
  customElements.define('union-hoodie-gallery', class extends HTMLElement {
    connectedCallback() {
      this.onClick = event => {
        const button = event.target.closest('[data-hoodie-view]');
        if (!button || !this.contains(button)) return;
        const panel = button.closest('[data-hoodie-color]');
        const main = panel.querySelector('[data-hoodie-main]');
        main.src = button.querySelector('img').src;
        main.alt = `Home Grown Hoodie - ${panel.dataset.hoodieColor} - ${button.dataset.hoodieView}`;
        panel.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      };
      this.onChange = event => {
        const color = {'Royal':'royal','Forest Green':'forest','Black':'charcoal'}[event.target.value];
        if (!color || !this.querySelector(`[data-hoodie-color="${color}"]`)) return;
        this.querySelectorAll('[data-hoodie-color]').forEach(panel => { panel.hidden = panel.dataset.hoodieColor !== color; });
        this.dataset.color = color;
      };
      this.scope = this.closest('[data-section-type="product-page"]') || this.parentElement;
      this.addEventListener('click', this.onClick);
      this.scope.addEventListener('change', this.onChange);
      this.onSwatch = event => { const swatch = event.target.closest('.product-option-item[data-value]'); if (swatch) this.onChange({target: {value: swatch.dataset.value}}); };
      this.scope.addEventListener('click', this.onSwatch);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.scope?.removeEventListener('change', this.onChange);
      this.scope?.removeEventListener('click', this.onSwatch);
    }
  });
}
